export enum Selection {
    Company = 'company',
    Reseller = 'reseller',
    Location = 'location',
    Employee = 'employee',
    System = 'system',
}

export type FilterInput = {
    companies: { [key: string]: boolean };
    resellers: { [key: string]: boolean };
    locations: { [key: string]: boolean };
};
